import React from 'react';
import validate from 'validate.js';
import { filter } from 'lodash';
import validateParkingForm from '../../app-parking-info/forms/validateParkingForm';
import validateSurveillanceForm from '../../app-surveillance-info/forms/validateSurveillanceForm';
import { FormattedMessage } from 'react-intl';

const validateSpaceTag = ({
  type_tag,
  is_available = false,
  types = {},
  description = '',
  has_surveillance = false,
  surveillance_description = '',
  overnight_stays
}) => {
  const optionMessage = <FormattedMessage id="hosting.validate_space_tag_form.select_option" defaultMessage="Please select an option" />;
  const spaceMessage = <FormattedMessage id="hosting.validate_space_tag_form.enter_space" defaultMessage="Please enter a type of space" />;
  validate.validators.parkingTypes = (value) => {
    return filter(value, (type) => type).length ? undefined : optionMessage;
  };

  return {
    type_tag: validate.single(type_tag,
      {
        presence: {
          allowEmpty: false,
          message: spaceMessage
        }
      }),
    overnight_stays: validate.single(overnight_stays, {
      presence: {
        allowEmpty: false,
        message: optionMessage
      }
    }),
    ...validateParkingForm({ is_available, types, description }),
    ...validateSurveillanceForm({ has_surveillance, surveillance_description })
  };
};

export default validateSpaceTag;
